// extracted by mini-css-extract-plugin
module.exports = {"invite":"style_invite__Mr2d3","invite-title":"style_invite-title__mdvMs","invite-description":"style_invite-description__ZVoTt","invite-icon":"style_invite-icon__quAuj"};